<div fxLayout="row" fxLayoutAlign="space-between top">
  <span mat-dialog-title>{{ 'drivers.driverDeactivationDialog.headline' | translate }}</span>
  <button mat-icon-button [mat-dialog-close]="false">
    <mat-icon class="material-icons">close</mat-icon>
  </button>
</div>
<div>
  <mat-dialog-content>
    {{ 'drivers.driverDeactivationDialog.text' | translate }}

    <div class="confirmation-data">
      <div>{{ 'drivers.firstName' | translate }}:</div>
      <div>{{ data.driver.firstName }}</div>

      <div>{{ 'drivers.lastName' | translate }}:</div>
      <div>{{ data.driver.lastName }}</div>

      <div>{{ 'drivers.abbreviation' | translate }}:</div>
      <div>{{ data.driver.abbreviation }}</div>

      <div>{{ 'drivers.licenseClass' | translate }}:</div>
      <div>{{ data.driver.licenseClass | licenseClass | async }}</div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-raised-button color="primary" [mat-dialog-close]="true">
      <mat-icon>check</mat-icon>
      {{ 'core.confirmBtn' | translate }}
    </button>
    <button mat-raised-button [mat-dialog-close]="false" color="primary">
      <mat-icon>close</mat-icon>
      {{ 'core.cancelBtn' | translate }}
    </button>
  </mat-dialog-actions>
</div>

